import { atom } from "recoil";

export const dateTimeWhenFNOLOpenedState = atom({
  key: "dateTimeWhenFNOLOpenedState",
  default: null,
});
